const types = {
    "ARCHIEVE_BULK_START" : "ARCHIEVE_BULK_START",
    "ARCHIEVE_BULK_SUCCESS" : "ARCHIEVE_BULK_SUCCESS",
    "ARCHIEVE_BULK_ERROR" : "ARCHIEVE_BULK_ERROR",
}   

export default types;